import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_46hn96hpk5: FaireBrandEntity = {
  token: "b_46hn96hpk5",
  type: "brand",
  name: "Wilton Mettler LLC",
  avatarUrl:
    "https://cdn.faire.com/fastly/13c2d4fb3d89c4b309dc1abe46c3e257c939eb7a0851d069bb728dcb211ecb60.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/276c7f442987de454161b2b6f22151ea7e5729fbcbbc59384081da5ab527e50a.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/13c2d4fb3d89c4b309dc1abe46c3e257c939eb7a0851d069bb728dcb211ecb60.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/276c7f442987de454161b2b6f22151ea7e5729fbcbbc59384081da5ab527e50a.jpeg",
  location: "Citrus Heights, CA, USA",
  minimumOrderDollars: 35,
  rating: 5,
  reviewCount: 4,
  isTopShop: true,
  isInsider: true,
  description:
    "Wilton Mettler is dedicated to bringing the world’s best vegan and gluten free brands to market, offering healthier alternatives without compromise on taste or quality. Our mission is to make nourishing choices effortless by transforming everyday foods and drinks into delicious options that support both body and mind. Every product we import is crafted with high-quality ingredients and inspired by the latest flavor trends, ensuring they are as satisfying as they are wholesome.\n\nWe believe that enjoying food should never come with guilt, and we are proud to support a global movement that reduces reliance on animal products, promotes wellness, and respects the planet. Through thoughtful sourcing and a commitment to sustainability, Wilton Mettler seeks to make it easier for everyone to live well while making a positive impact on the world.",
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:51:46.119Z",
    importedBy: "entity-db-cli",
  },
};
